
import React from 'react';
import { Progress } from "@/components/ui/progress";
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

interface ScanProgressBarProps {
  progressPercentage: number;
  currentTheme: string | null;
  allThemes: string[];
}

const ScanProgressBar: React.FC<ScanProgressBarProps> = ({
  progressPercentage,
  currentTheme,
  allThemes
}) => {
  // Create accessible value text for screen readers
  const ariaValueText = `${progressPercentage}% voltooid, huidige sectie: ${currentTheme}`;
  
  return (
    <div className="mb-8">
      {/* Progress percentage */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-gray-500">Stap {progressPercentage}% voltooid</span>
        <span className="text-sm font-medium text-brand-blue">{currentTheme}</span>
      </div>
      
      {/* Progress bar - now with proper accessibility attributes */}
      <Progress 
        value={progressPercentage} 
        className="h-2"
        ariaLabel="Voortgang telemarketing scan" 
        ariaValueText={ariaValueText}
      />
      
      {/* Theme badges */}
      <div className="flex flex-wrap gap-2 mb-6 mt-4 justify-center" aria-hidden="true">
        {allThemes.map((theme, index) => {
          const isActive = theme === currentTheme;
          const isPast = allThemes.indexOf(currentTheme || "") > index;
          
          return (
            <div 
              key={theme}
              className={cn(
                "px-3 py-1 rounded-full text-xs font-medium transition-all duration-300",
                isActive ? "bg-brand-blue text-white scale-110" : 
                isPast ? "bg-green-100 text-green-800" : 
                "bg-gray-100 text-gray-500"
              )}
            >
              {isPast && <Check className="inline-block mr-1 h-3 w-3" />}
              {theme}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ScanProgressBar;
